import React, { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";

// context
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import { Media, FoodTotal, FoodDetail } from "../common";
import CommentList from "./CommentList";
import NewCommentInput from "./NewCommentInput";

// redux
import { RootState } from "bodycodi/cmap/app/redux/store";

// utils
import { api } from "bodycodi/cmap/app/js/api";

// assets
import commentIcon from "bodycodi/cmap/app/img/icon_comment.png";
import OneToOneIcon from "bodycodi/cmap/app/svg/community_onetoone_icon.svg";
import GroupIcon from "bodycodi/cmap/app/svg/community_group_icon.svg";

// types
import { CommunityDetailProps } from "./types";

const CommunityDetail = ({ details }: CommunityDetailProps) => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);
  const { seqPartnerCoach } = useSelector((state: RootState) => state.partner);
  const [commentList, setCommentList] = useState<any[]>([]);
  const [refresh, setRefresh] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [fullInfo, setFullInfo] = useState<any>({});

  const fetchComments = async () => {
    dispatch({ type: "LOADING_START" });
    setLoading(true);
    try {
      await api
        .get(`/community/${seqPartnerCoach}/posts/${details.uploadId}/comments`, {
          params: {
            upldId: details.uploadId,
            seqPartnerCoach,
          },
        })
        .then(({ data }) => {
          setCommentList(data.comments);
          setLoading(false);
          dispatch({ type: "LOADING_END" });
        });
    } catch (error) {
      setLoading(false);
      dispatch({ type: "LOADING_END" });
      console.error(error);
    }
  };

  const fetchCommunity = async () => {
    try {
      dispatch({ type: "LOADING_START" });
      await api.get(`/community/${seqPartnerCoach}/posts/${details?.uploadId}`).then(({ data }) => {
        setFullInfo(data);
      });
    } catch (error) {
      dispatch({ type: "LOADING_END" });
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCommunity();
  }, []);

  useEffect(() => {
    fetchComments();
  }, [refresh]);

  const refreshCommentList = () => {
    setRefresh((prev) => prev + 1);
  };

  return (
    <>
      <div className="popup-body comunity-content-body-wrap" style={{ padding: "0px" }}>
        <div
          className="comunity-content-body"
          style={{
            padding: "24px",
            paddingBottom: fullInfo.postType === "MEMBER_FOODLENS_UPLOAD" ? 0 : "24px",
          }}
        >
          {fullInfo.postType === "MEMBER_FOODLENS_UPLOAD" ? (
            <>
              <FoodTotal foodLensInfo={fullInfo.foodLensInfo} isList={false} />
              <FoodDetail foodLensInfo={fullInfo.foodLensInfo} />
            </>
          ) : (
            <div className="media preview">
              <Media files={fullInfo.files} isDetail={true} />
            </div>
          )}
          <div className="decs">
            <div className="text">{fullInfo?.uploadContent}</div>
          </div>
        </div>

        <div className="divider" />
        <div className="comunity-content-footer with-divider">
          <div className="commnet">
            <img src={commentIcon} />
            {commentList.length > 0 ? `댓글 ${commentList.length}` : `댓글쓰기`}
          </div>

          {details?.members.length > 1 ? <img src={GroupIcon} /> : <img src={OneToOneIcon} />}
        </div>

        <CommentList list={commentList} refresh={refreshCommentList} />
        <NewCommentInput
          communityId={fullInfo.uploadId}
          seqPartnerCoach={seqPartnerCoach}
          refresh={refreshCommentList}
          autoFocus={!loading && state.goToCommentSection && details.commentCount === 0}
        />
      </div>
    </>
  );
};

export default CommunityDetail;
